import request from '../../utils/requests'

/**
 * Tag: ClassTimeTable
 */

const baseUrl ="/api/ClassTimeTable";



/**
 * 获取一个排课详情
 * @param {*} param
 * {
 *    scheduleId Desc: Required:true
 * }
 */
async function _getSimpleArrange(param) {
  return request(baseUrl+'/getSimpleArrange',{
    method: 'GET',
    params: param,
  });

}



/**
 * 单次排课
 * @param {*} body
 * {
 *    ScheduleId Desc:排课主键 Required:false
 *    ScheduleDate Desc:上课日期 Required:false
 *    StartHour Desc:开始小时 Required:false
 *    StartMinute Desc:开始分钟 Required:false
 *    EndHour Desc:结束小时 Required:false
 *    EndMinute Desc:结束分钟 Required:false
 *    TimeTableId Desc:课程安排表主键 0 新增 大于0 修改 Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    CourseName Desc:课程名称 Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    ClassName Desc:班级名称 Required:false
 *    DeductCount Desc:扣课次数 Required:false
 *    TeacherIds Desc:老师Id Required:false
 *    AssistantIds Desc:助教Id Required:false
 *    OrgSiteId Desc:上课场地 Required:false
 *    LessonPlan Desc:教案 Required:false
 *    OrgId Desc: Required:false
 *    BranchId Desc: Required:false
 *    PlanType Desc:排课方式 0:单次 1:重复 Required:false
 *    BookCancelSetting Desc:开启预约模式后可设置，开课前多长时间（分钟）不可取消预约 Required:false
 *    MaxStuCount Desc:最大人数（学生数量） Required:false
 * }
 */
async function _simpleArrange(body) {
  return request(baseUrl+'/simpleArrange',{
    method: 'POST',
    body: body,
  });

}



/**
 * 重复排课
 * @param {*} body
 * {
 *    ScheduleStartDate Desc:上课开始日期 Required:false
 *    ScheduleEndDate Desc:上课结束日期 Required:false
 *    Rules Desc:上课规则集合 Required:false
 *    TimeTableId Desc:课程安排表主键 0 新增 大于0 修改 Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    CourseName Desc:课程名称 Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    ClassName Desc:班级名称 Required:false
 *    DeductCount Desc:扣课次数 Required:false
 *    TeacherIds Desc:老师Id Required:false
 *    AssistantIds Desc:助教Id Required:false
 *    OrgSiteId Desc:上课场地 Required:false
 *    LessonPlan Desc:教案 Required:false
 *    OrgId Desc: Required:false
 *    BranchId Desc: Required:false
 *    PlanType Desc:排课方式 0:单次 1:重复 Required:false
 *    BookCancelSetting Desc:开启预约模式后可设置，开课前多长时间（分钟）不可取消预约 Required:false
 *    MaxStuCount Desc:最大人数（学生数量） Required:false
 * }
 */
async function _multipleArrange(body) {
  return request(baseUrl+'/multipleArrange',{
    method: 'POST',
    body: body,
  });

}



/**
 * 常规课程表查询
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    ClassName Desc:班级名称 Required:false
 *    IsALLTA Desc:false区分老师或者助教 true 不区分 Required:false
 *    TeacherId Desc:老师Id Required:false
 *    AssistantId Desc:助教Id Required:false
 *    StartDate Desc:开始日期 优先于 StartDateTime Required:false
 *    EndDate Desc:结束日期 Required:false
 *    IsIncludeDateTimeRange Desc:是否查询包含再 StartDateTime 之间 EndDateTime 默认 false Required:false
 *    StartDateTime Desc:开始日期时间 Required:false
 *    EndDateTime Desc:结束日期时间 Required:false
 *    OrgSiteId Desc: Required:false
 *    OrgId Desc: Required:false
 *    BranchId Desc: Required:false
 *    CourseTypeId Desc:课程类型Id 字典表 CourseType Required:false
 *    IsDone Desc:是否已经上课 -1 全部 0 未上课 1已上课 Required:false
 *    IsStuAttend Desc:学员签到状态，-1 全部， 0 未签到，1 已签到 Required:false
 *    BranchIdList Desc: Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getScheduleList(body) {
  return request(baseUrl+'/getScheduleList',{
    method: 'POST',
    body: body,
  });

}


/**
 * 常规课程表查询
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    ClassName Desc:班级名称 Required:false
 *    IsALLTA Desc:false区分老师或者助教 true 不区分 Required:false
 *    TeacherId Desc:老师Id Required:false
 *    AssistantId Desc:助教Id Required:false
 *    StartDate Desc:开始日期 优先于 StartDateTime Required:false
 *    EndDate Desc:结束日期 Required:false
 *    IsIncludeDateTimeRange Desc:是否查询包含再 StartDateTime 之间 EndDateTime 默认 false Required:false
 *    StartDateTime Desc:开始日期时间 Required:false
 *    EndDateTime Desc:结束日期时间 Required:false
 *    OrgSiteId Desc: Required:false
 *    OrgId Desc: Required:false
 *    BranchId Desc: Required:false
 *    CourseTypeId Desc:课程类型Id 字典表 CourseType Required:false
 *    IsDone Desc:是否已经上课 -1 全部 0 未上课 1已上课 Required:false
 *    IsStuAttend Desc:学员签到状态，-1 全部， 0 未签到，1 已签到 Required:false
 *    BranchIdList Desc: Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _GetScheduleListWeekExport(body) {
  return request(baseUrl+'/GetScheduleListWeekExport',{
    method: 'POST',
    body: body,
  });

}

/**
 * 场地课程表查询
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    ClassName Desc:班级名称 Required:false
 *    IsALLTA Desc:false区分老师或者助教

true 不区分 Required:false
 *    TeacherId Desc:老师Id Required:false
 *    AssistantId Desc:助教Id Required:false
 *    StartDate Desc:开始日期 优先于 StartDateTime Required:false
 *    EndDate Desc:结束日期 Required:false
 *    IsIncludeDateTimeRange Desc:是否查询包含再 StartDateTime 之间 EndDateTime 默认 false Required:false
 *    StartDateTime Desc:开始日期时间 Required:false
 *    EndDateTime Desc:结束日期时间 Required:false
 *    OrgSiteId Desc: Required:false
 *    OrgId Desc: Required:false
 *    BranchId Desc: Required:false
 *    CourseTypeId Desc:课程类型Id 字典表 CourseType Required:false
 *    IsDone Desc:是否已经上课 -1 全部 0 未上课 1已上课 Required:false
 *    IsStuAttend Desc:学员签到状态，-1 全部， 0 未签到，1 已签到 Required:false
 *    BranchIdList Desc: Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getScheduleForSiteList(body) {
  return request(baseUrl+'/getScheduleForSiteList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 排课课程表查询
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    ClassName Desc:班级名称 Required:false
 *    IsALLTA Desc:false区分老师或者助教

true 不区分 Required:false
 *    TeacherId Desc:老师Id Required:false
 *    AssistantId Desc:助教Id Required:false
 *    StartDate Desc:开始日期 优先于 StartDateTime Required:false
 *    EndDate Desc:结束日期 Required:false
 *    IsIncludeDateTimeRange Desc:是否查询包含再 StartDateTime 之间 EndDateTime 默认 false Required:false
 *    StartDateTime Desc:开始日期时间 Required:false
 *    EndDateTime Desc:结束日期时间 Required:false
 *    OrgSiteId Desc: Required:false
 *    OrgId Desc: Required:false
 *    BranchId Desc: Required:false
 *    CourseTypeId Desc:课程类型Id 字典表 CourseType Required:false
 *    IsDone Desc:是否已经上课 -1 全部 0 未上课 1已上课 Required:false
 *    IsStuAttend Desc:学员签到状态，-1 全部， 0 未签到，1 已签到 Required:false
 *    BranchIdList Desc: Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getScheduleListPaging(body) {
  return request(baseUrl+'/getScheduleListPaging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 学生排课
 * @param {*} body
 * {
 *    StartDate Desc:开始日期 Required:false
 *    EndDate Desc:结束日期 Required:false
 *    OrgSiteId Desc: Required:false
 *    StudentId Desc: Required:false
 *    OrgId Desc: Required:false
 *    BranchId Desc: Required:false
 * }
 */
async function _getStudentScheduleList(body) {
  return request(baseUrl+'/getStudentScheduleList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取日程详情
 * @param {*} param
 * {
 *    scheduleId Desc: Required:true
 * }
 */
async function _getOneScheduleInfo(param) {
  return request(baseUrl+'/getOneScheduleInfo',{
    method: 'GET',
    params: param,
  });

}



/**
 * 一个课程时间段移除一个学生
 * @param {*} param
 * {
 *    classTimeTableSSRId Desc: Required:true
 * }
 */
async function _removeOneScheduleStudentById(param) {
  return request(baseUrl+'/removeOneScheduleStudentById',{
    method: 'GET',
    params: param,
  });

}



/**
 * 一个课程时间段移除一个学生
 * @param {*} param
 * {
 *    scheduleId Desc: Required:true
 *    personId Desc: Required:true
 *    isTrial Desc: Required:true
 * }
 */
async function _removeOneScheduleStudent(param) {
  return request(baseUrl+'/removeOneScheduleStudent',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取某课时学员列表
 * @param {*} param
 * {
 *    classTimeTableScheduleId Desc:课程课时安排Id Required:true
 *    branchId Desc:校区Id Required:true
 * }
 */
async function _getClassSetStudentList(param) {
  return request(baseUrl+'/getClassSetStudentList',{
    method: 'GET',
    params: param,
  });

}



/**
 * 课时设置学员新增(支持请假记录Id)
 * @param {*} body
 * {
 *    ScheduleId Desc:课程某课时主键Id Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    StudentIds Desc:学生列表 Required:false
 *    IsTrial Desc:是否体验 1正常学员 2串课学员3体验学员 Required:false
 *    BranchId Desc:校区ID Required:false
 * }
 */
async function _addClassStudentNew(body) {
  return request(baseUrl+'/addClassStudentNew',{
    method: 'POST',
    body: body,
  });

}

/**
 * 检查预约是否可行
 * @param {*} body
 * {
 *    ScheduleId Desc:课程某课时主键Id Required:false
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    StudentIds Desc:学生列表 Required:false
 *    IsTrial Desc:是否体验 1正常学员 2串课学员3体验学员 Required:false
 *    BranchId Desc:校区ID Required:false
 * }
 */
async function _CheckBookPerson(body) {
  return request(baseUrl+'/CheckBookPerson',{
    method: 'POST',
    body: body,
  });

}



/**
 * 修改人员请假记录Id
 * @param {*} body
 * {
 *    ScheduleId Desc:课时Id Required:false
 *    StudentId Desc:人员Id Required:false
 *    LeaveRecordId Desc:请假记录 Required:false
 * }
 */
async function _updateClassStudentLeave(body) {
  return request(baseUrl+'/updateClassStudentLeave',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取当前课时未选的学生 分页
 * @param {*} param
 * {
 *    req.classTimeTableScheduleId Desc:课时ID Required:false
 *    req.courseId Desc:课程Id Required:false
 *    req.branchId Desc:校区Id Required:false
 *    req.orgId Desc:机构Id Required:false
 *    req.search Desc:搜索 姓名/手机号 Required:false
 *    req.studentNo Desc:学号 Required:false
 *    req.start Desc:开始行数 从0开始 Required:false
 *    req.length Desc:页面大小 Required:false
 * }
 */
async function _getUnSetStudentList(param) {
  return request(baseUrl+'/getUnSetStudentList',{
    method: 'GET',
    params: param,
  });

}



/**
 * 跨校区查询学生 精确查询
 * @param {*} param
 * {
 *    search Desc: Required:true
 *    branchId Desc: Required:true
 * }
 */
async function _getCurrentOrgStudents(param) {
  return request(baseUrl+'/getCurrentOrgStudents',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取客户列表 分页
 * @param {*} param
 * {
 *    req.classTimeTableScheduleId Desc:课时ID Required:false
 *    req.courseId Desc:课程Id Required:false
 *    req.branchId Desc:校区Id Required:false
 *    req.orgId Desc:机构Id Required:false
 *    req.search Desc:搜索 姓名/手机号 Required:false
 *    req.start Desc:开始行数 从0开始 Required:false
 *    req.length Desc:页面大小 Required:false
 * }
 */
async function _getCustomerList(param) {
  return request(baseUrl+'/getCustomerList',{
    method: 'GET',
    params: param,
  });

}



/**
 * 客户中心：给客户办理体验数据源
 * @param {*} body
 * {
 *    BranchId Desc:校区ID Required:true
 *    CourseId Desc:课程ID Required:true
 *    ClassId Desc:班级ID Required:false
 *    CustomerId Desc:客户ID Required:true
 *    OrgId Desc:机构ID Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getDealWithExpScheduleForC(body) {
  return request(baseUrl+'/getDealWithExpScheduleForC',{
    method: 'POST',
    body: body,
  });

}



/**
 * 客户：批量添加上课课时
 * @param {*} body
 * {
 *    req Desc: Required:true
 * }
 */
async function _addRelationForC(body) {
  return request(baseUrl+'/addRelationForC',{
    method: 'POST',
    body: body,
  });

}

/**
 *  客户：批量添加上课课时检查
 * @param {*} body
 * {
 *    req Desc: Required:true
 * }
 */
async function _CheckAddRelationForC(body) {
  return request(baseUrl + '/CheckAddRelationForC', {
    method: 'POST',
    body: body,
  });

}



/**
 * 获取学员/客户办理体验（查询的是关系表）
 * @param {*} body
 * {
 *    PersonId Desc:客户/学员ID：必填 Required:true
 *    IsTrial Desc:学员类型：枚举：EStudentType Required:false
 *    BranchId Desc:校区ID：必填 Required:false
 *    IsDel Desc:是否删除,默认查全部（1：是，0：否，-1：全部） Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStudentScheduleListForC(body) {
  return request(baseUrl+'/getStudentScheduleListForC',{
    method: 'POST',
    body: body,
  });

}



/**
 * 客户中心办理体验分页查询
 * @param {*} body
 * {
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    FollowUpUserId Desc:跟进人ID Required:false
 *    CustomerStatus Desc:跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:false
 *    CourseId Desc:体验课程ID Required:false
 *    ClassId Desc:体验班级ID Required:false
 *    BranchId Desc:体验校区(机构时不传，校区传当前校区ID) Required:false
 *    CreateUserId Desc:经办人（实际查的是创建人） Required:false
 *    ScheduleTimeStart Desc:课时时间-开始（精确到日期） Required:false
 *    ScheduleTimeEnd Desc:课时时间-结束（精确到日期） Required:false
 *    CreateTimeStart Desc:办理时间-开始（精确到日期） Required:false
 *    CreateTimeEnd Desc:办理时间-结束（精确到日期） Required:false
 *    IsDel Desc:是否删除,默认查全部（1：是，0：否，-1：全部） Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getDealWithExpList(body) {
  return request(baseUrl+'/getDealWithExpList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 批量删除体验记录
 * @param {*} body
 * {
 *    req Desc: Required:true
 * }
 */
async function _batchDelExpRecordList(body) {
  return request(baseUrl+'/batchDelExpRecordList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 导出数据客户中心办理体验
 * @param {*} body
 * {
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    FollowUpUserId Desc:跟进人ID Required:false
 *    CustomerStatus Desc:跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:false
 *    CourseId Desc:体验课程ID Required:false
 *    ClassId Desc:体验班级ID Required:false
 *    BranchId Desc:体验校区(机构时不传，校区传当前校区ID) Required:false
 *    CreateUserId Desc:经办人（实际查的是创建人） Required:false
 *    ScheduleTimeStart Desc:课时时间-开始（精确到日期） Required:false
 *    ScheduleTimeEnd Desc:课时时间-结束（精确到日期） Required:false
 *    CreateTimeStart Desc:办理时间-开始（精确到日期） Required:false
 *    CreateTimeEnd Desc:办理时间-结束（精确到日期） Required:false
 *    IsDel Desc:是否删除,默认查全部（1：是，0：否，-1：全部） Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _expExcel(body) {
  return request(baseUrl+'/expExcel',{
    method: 'POST',
    body: body,
  });

}



/**
 * 移除一个课时
 * @param {*} param
 * {
 *    classTimeTableScheduleId Desc: Required:true
 * }
 */
async function _removeOneSchedule(param) {
  return request(baseUrl+'/removeOneSchedule',{
    method: 'GET',
    params: param,
  });

}



/**
 * 批量删除课时
 * @param {*} body
 * {
 *    ScheduleIds Desc:课时Id集合 Required:false
 *    BranchId Desc:校区 Required:false
 *    OrgId Desc:机构 Required:false
 * }
 */
async function _batchRemoveSchedule(body) {
  return request(baseUrl+'/batchRemoveSchedule',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取课程学生 - 未排课打卡
 * @param {*} body
 * {
 *    CourseId Desc:课程 Required:false
 *    IsDivided Desc:是否已经分班 -1全部 0未分班 1已分班 Required:false
 *    Search Desc:姓名/手机号码 Required:false
 *    BranchId Desc:校区 Required:false
 *    OrgId Desc:机构 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStudentToCheckIn(body) {
  return request(baseUrl+'/getStudentToCheckIn',{
    method: 'POST',
    body: body,
  });

}



/**
 * 打卡 - 未排课打卡
 * @param {*} body
 * {
 *    StudentIds Desc:学生Id Required:false
 *    CourseId Desc:课程Id Required:false
 *    CourseName Desc:课程名称 Required:false
 *    ScheduleDate Desc:上课日期 Required:false
 *    DeductCount Desc:扣课次数 Required:false
 *    TeacherIds Desc:老师Id Required:false
 *    AssistantIds Desc:助教Id Required:false
 *    OrgSiteId Desc:上课场地 Required:false
 *    LessonPlan Desc:教案 Required:false
 *    BranchId Desc:校区 Required:false
 *    OrgId Desc:机构 Required:false
 *    AttendType Desc:签到类型 默认手动未排课打卡 Required:false
 * }
 */
async function _studentCheckIn(body) {
  return request(baseUrl+'/studentCheckIn',{
    method: 'POST',
    body: body,
  });

}



/**
 * 今日课时 批量更新
 * @param {*} body
 * {
 *    ScheduleIds Desc:课时Id列表 必传 Required:false
 *    TeacherIds Desc:老师Id列表 不传不更新 Required:false
 *    AssistantIds Desc:助教Id列表 不传不更新 Required:false
 *    OrgSiteId Desc:场地Id 不传不更新 Required:false
 *    DeductCount Desc:扣课次数 不传不更新 Required:false
 *    ScheduleDate Desc:课时日期 Required:false
 *    BranchId Desc:校区 Required:false
 *    OrgId Desc:机构 Required:false
 * }
 */
async function _batchScheduleArrangeUpdate(body) {
  return request(baseUrl+'/batchScheduleArrangeUpdate',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取某课时预约关注列表
 * @param {*} param
 * {
 *    scheduleId Desc:课程课时安排Id Required:true
 *    branchId Desc:校区Id Required:true
 *    search Desc:查询姓名/手机 Required:false
 * }
 */
async function _getScheduleFollowList(param) {
  return request(baseUrl+'/getScheduleFollowList',{
    method: 'GET',
    params: param,
  });

}



/**
 * 移除课时预约
 * @param {*} param
 * {
 *    scheduleId Desc:课程课时安排Id Required:true
 *    studentId Desc:学生Id Required:true
 *    branchId Desc:校区Id Required:true
 * }
 */
async function _removeScheduleFollow(param) {
  return request(baseUrl+'/removeScheduleFollow',{
    method: 'GET',
    params: param,
  });

}



/**
 * 关注课时
 * @param {*} param
 * {
 *    req.scheduleId Desc:课时Id Required:false
 *    req.studentId Desc:学生Id Required:false
 *    req.classId Desc:班级Id Required:false
 *    req.courseId Desc:课程Id Required:false
 *    req.branchId Desc:校区 Required:false
 *    req.orgId Desc:机构 Required:false
 * }
 */
async function _scheduleFollowAdd(param) {
  return request(baseUrl+'/scheduleFollowAdd',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取课时备课详情
 * @param {*} param
 * {
 *    scheduleId Desc:课时ID Required:true
 * }
 */
async function _getSchedulePrepareLessons(param) {
  return request(baseUrl+'/getSchedulePrepareLessons',{
    method: 'GET',
    params: param,
  });

}



/**
 * 编辑备课详情
 * @param {*} body
 * {
 *    ClassTimeTableScheduleId Desc:课时ID Required:false
 *    PrepareLessons Desc:备课详情 Required:false
 * }
 */
async function _editSchedulePrepareLessons(body) {
  return request(baseUrl+'/editSchedulePrepareLessons',{
    method: 'POST',
    body: body,
  });

}



/**
 * 设置课时的老师/助教
 * @param {*} body
 * {
 *    ScheduleId Desc:课时ID Required:false
 *    TeacherId Desc:老师IdList Required:false
 *    AssistantId Desc:助教IdList Required:false
 * }
 */
async function _editTeacherForSchedule(body) {
  return request(baseUrl+'/editTeacherForSchedule',{
    method: 'POST',
    body: body,
  });

}

/**
 * 排课冲突检测（重复）
 * @param {*} body 
 */
async function _getConflictScheduleList(body) {
  return request(baseUrl+'/GetConflictScheduleList',{
    method: 'POST',
    body: body,
  });

}

export default{
  _getSimpleArrange,
  _simpleArrange,
  _multipleArrange,
  _getScheduleList,
  _getScheduleForSiteList,
  _getScheduleListPaging,
  _getStudentScheduleList,
  _getOneScheduleInfo,
  _removeOneScheduleStudentById,
  _removeOneScheduleStudent,
  _getClassSetStudentList,
  _addClassStudentNew,
  _CheckBookPerson,
  _updateClassStudentLeave,
  _getUnSetStudentList,
  _getCurrentOrgStudents,
  _getCustomerList,
  _getDealWithExpScheduleForC,
  _addRelationForC,
  _CheckAddRelationForC,
  _getStudentScheduleListForC,
  _getDealWithExpList,
  _batchDelExpRecordList,
  _expExcel,
  _removeOneSchedule,
  _batchRemoveSchedule,
  _getStudentToCheckIn,
  _studentCheckIn,
  _batchScheduleArrangeUpdate,
  _getScheduleFollowList,
  _removeScheduleFollow,
  _scheduleFollowAdd,
  _getSchedulePrepareLessons,
  _editSchedulePrepareLessons,
  _editTeacherForSchedule,
  _getConflictScheduleList,
  _GetScheduleListWeekExport
}




// WEBPACK FOOTER //
// ./src/services/classTimeTable.js